//=> https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_shipping_info

class SelectPaymentMethodEventListener {
    // Language: javascript
    // Path: SelectShippingEventListener.js
    // Compare this snippet from EventListener.js:

    get PaymentMethod() {
        return ".gtm-payment-method";
    }
    get CheckoutProducts() {
        return ".gtm-checkout-products";
    }
    get CheckoutCart() {
        return ".gtm-checkout-cart";
    }
    get DefaultEventName() {
        return "click";
    }

    constructor(element, eventName = this.DefaultEventName) {
        this.element = element;
        this.eventName = eventName;
    }
    callback() {
        console.log(this);
        const dataLayer = new DataLayer();
        dataLayer.clear();
        var methodName;
        var totalPrice;
        var items = [];
        var currency;

        methodName = !!this.dataset
            ? this.dataset.bank
            : this.element.dataset.bank;

        var checkoutProducts = document.querySelectorAll(
            SelectPaymentMethodEventListener.prototype.CheckoutProducts
        );
        var checkoutCart = document.querySelector(
            SelectPaymentMethodEventListener.prototype.CheckoutCart
        );

        for (var i = 0; i < checkoutProducts.length; i++) {
            var cartItem = checkoutProducts[i];
            var analyticsData = cartItem.dataset.analytics
                ? JSON.parse(cartItem.dataset.analytics)
                : null;

            if (analyticsData && cartItem.dataset) {
                var analticsDataProducts = analyticsData.products
                    ? analyticsData.products[0]
                    : null;
                totalPrice = checkoutCart.dataset.carttotal;
                currency = checkoutCart.dataset.cartcurrency;

                var item = {
                    item_id: analticsDataProducts.code,
                    item_name: analticsDataProducts.name,
                    item_brand: analticsDataProducts.brand,
                    item_category: analticsDataProducts.category,
                };

                if (analticsDataProducts.categories) {
                    var splitCategories =
                        analticsDataProducts.categories.split(";");
                    for (var j = 0; j < splitCategories.length; j++) {
                        if (j == 0) {
                            item.item_category = splitCategories[j];
                        } else {
                            item["item_category" + j] = splitCategories[j];
                        }
                    }
                }

                items.push(item);
            }
        }

        if (items.length > 0) {
            SendData(dataLayer);
        }

        function SendData(dataLayer) {
            dataLayer
                .push({
                    event: "add_payment_info",
                    ecommerce: {
                        currency: currency,
                        value: totalPrice,
                        payment_type: methodName,
                        items: items,
                    },
                })
                .then(() => {
                    setTimeout(() => {
                        var instanceActivate = new ActivateGtm();
                        instanceActivate.activateSelectPaymentMethod(false);
                    }, 1000);
                    console.log("GTM pushed add_payment_info event");
                })
                .catch((error) => {
                    console.warn("GTM error add_payment_info event", error);
                });

            if (typeof gtag !== "undefined" && !!gtag) {
                gtag("event", "add_payment_info", {
                    event_category: "Enhanced Ecommerce",
                    event_label: "add payment info",
                    value: totalPrice,
                    currency: currency,
                    payment_type: methodName,
                    items: items,
                });
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            SelectPaymentMethodEventListener.prototype.callback
        );
    }

    remove() {
        this.element.removeEventListener(
            this.eventName,
            SelectPaymentMethodEventListener.prototype.callback
        );
    }
}
